<template>
    <th v-if="th" :class="(column.type == 'number' || column.type == 'percent' ? 'number-columns' : '') + ' ' + customClass">
        <div class="header" :class="{'no-sort': noSort, 'no-filter': !column.filter}"  v-if="floated">
            <div class="header__content">
                <div class="sort-controls" @click="handleHeaderClick(column.dataField)" :class="{'no-sort': noSort}">
                    <span>{{column.colTitle}}</span>
                    <div class="sort-icons">
						<i class="fas fa-angle-up header__sort-icon-up svg"></i>
						<i class="fas fa-angle-down header__sort-icon-down svg"></i>
                    </div>
                </div>
                <div class="filter-controls" v-if="column.filter" :class="{'no-filter': !column.filter}" @click="handleFilterClick(column.dataField)">
                    <v-button
                        :customLabel="''"
                        :svg="'icon-filter'"
                        :class="{ 'filtered': this.rcdcFilterValue}"
                        srOnlyLabel="'filter'"
                    />
                </div>
                <!-- <div class="collapse column-filter" v-if="column.filter" :id="column.dataField + '-filter-collapse'">
                    <div class="column-filter__wrapper">
                         <div class="form-group">
                            <label :for="column.dataField + '-filter-input'" class="sr-only">Filter Value</label>
                            <input type="text" class="form-control" :id="column.dataField + '-filter-input'" v-model="filterInput" @input="columnFilterOnInput()">
                        </div>
                        <div class="column-filter__controls">
                            <v-button
                                :customLabel="'Reset'"
                                :customClass="'btn-secondary'"
                                data-toggle="collapse"
                                :data-target="'#' + column.dataField + '-filter-collapse'"
                                aria-expanded="false"
                                :aria-controls="'#' + column.dataField + '-filter-collapse'"
                                @click="resetFilter()"
                            />
                            <v-button
                                :customLabel="'Done'"
                                :customClass="'btn-primary'"
                                data-toggle="collapse"
                                :data-target="'#' + column.dataField + '-filter-collapse'"
                                aria-expanded="false"
                                :aria-controls="'#' + column.dataField + '-filter-collapse'"
                            />
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="header" v-else>
            <span>{{column.colTitle}}</span>
        </div>
    </th>
    <td v-else :class="customClass">
        <div v-if="column.dataField === 'rcdcCategory'" class="link-title">
            <a href @click.prevent="handleRowClick({name: 'rcdc', data: data})">{{filters.categoryNameFilter(data[column.dataField])}} <i class="fas fa-angle-right icon-right"></i></a>
        </div>
        <div v-else-if="column.dataField === 'ic'" class="link-title">
            <a href @click.prevent="handleRowClick({name: 'ic', data: data})">{{data[column.dataField]}} <i class="fas fa-angle-right icon-right"></i></a>
        </div>
        <div v-else-if="column.dataField === 'studyPopulation'">
            <span>{{icTableRowName}}</span>
        </div>
        <div v-else-if="column.type == 'number' || column.type == 'percent'" class="number-columns">{{ filters.formatPercent(data[column.dataField], column.type) }}</div>
        <div v-else>{{data[column.dataField]}}</div>
    </td>
</template>
<script>
import bus from '@/js/event-bus.js';

export default {
    name: 'v-col',
    props: {
        tableName: {
            type: String
        },
        data: {
            default: null
        },
        th: {
            type: Boolean
        },
        floated: {
            type: Boolean
        },
        column: {
            default: null,
            required: true
        },
        customClass: {
            default: '',
            type: String
        },
        noSort: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        icTableRowName () {
            var text = '';

            switch (this.tableName) {
                case 'raceTable':
                    if (this.data.studyPopulation === 'Exclude Singles') {
                        text = 'Excluding Single Race Studies';
                    } else {
                        text = 'All Studies';
                    }
                    break;
                case 'genderTable':
                    if (this.data.studyPopulation === 'Exclude Singles') {
                        text = 'Excluding Single Sex/Gender Studies';
                    } else {
                        text = 'All Studies';
                    }
                    break;
                case 'ethnicityTable':
                    if (this.data.studyPopulation === 'Exclude Singles') {
                        text = 'Excluding Single Ethnicity Studies';
                    } else {
                        text = 'All Studies';
                    }
                    break;
            }

            return text;
        }
    },
    watch: {
        rcdcFilterValue () {
            this.filterInput = this.rcdcFilterValue;
        }
    },
    data: function () {
        return {
            timer: 0,
            filterInput: null,
            filters: window.filters 
        };
    },
    mounted () {
        this.filterInput = this.rcdcFilterValue;
        $(this.$el).find('.collapse').on('shown.bs.collapse', function () {
            $(this).find('input').focus();
        });
    },
    methods: {
        handleHeaderClick (dataField) {
            bus.$emit('sort:click', dataField);
        },
        handleRowClick (data) {
            bus.$emit('row:click', data);
        },
        handleFilterClick () {
            $(this.$el).find('.toggle').toggle('toggle');
        },
        columnFilterOnInput () {
            this.timer++;

            // setTimeout(() => {
            //     this.timer--;

            //     if (this.timer === 0) {
            //         this.rcdcFilterValue = this.filterInput;
            //         this.$emit('filter');
            //     }
            // }, 1000);

            if (!this.filterInput || this.filterInput.length >= 3) {
                this.rcdcFilterValue = this.filterInput;
                bus.$emit('filter');
            }
        },
        resetFilter () {
            if (this.rcdcFilterValue) {
                this.rcdcFilterValue = null;
                this.$nextTick(() => {
                    bus.$emit('filter');
                });
            }
        }
    }
};
</script>
<style lang="scss">
.link-title {
    a {
        font-weight: bold;

        &:hover,
        &:active {
            color: #20558a;
            text-decoration: none;
        }
    }

    .icon-right {
        width: 10px;
        height: 10px;
        color: #A8B9D4;
        top: -1px;
        position: relative;
    }
}

.number-columns {
    text-align: right;
}

td {
    .number-columns {
        padding-right: 40px;
    }
}
</style>



